var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('game-stepper',{attrs:{"currentSiteId":_vm.siteId,"currentSiteUuid":_vm.currentSiteUuid,"currentSiteLangs":_vm.availableLangs,"platform-type":_vm.platformType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }